import { gql, useQuery } from "@apollo/client";
import useServerTime from "@repo/shopify/hooks/useServerTime";
import type { IIndexMetaObjectQuery } from "@repo/shopify/queries/metaobject-gql";
import { indexMetaobjectQuery } from "@repo/shopify/queries/metaobject-gql";
import type {
  MetafieldReference,
  MetafieldReferenceEdge,
  Metaobject,
} from "@shopify/hydrogen-react/storefront-api-types";
import React, { useEffect, useMemo } from "react";

import HomeCard from "@molecules/HomeCard";

import { useLayoutStore } from "@store/layout";

const getValue = (node: MetafieldReference | undefined, key: string) => {
  if (!node) return null;
  return (node as Metaobject)?.fields.find((item) => item.key === key);
};

export default function Home() {
  const { showFooter } = useLayoutStore();

  const { serverTime } = useServerTime();

  useEffect(() => {
    showFooter(true);
    window.scrollTo(0, 0);
  }, []);

  const { data, loading } = useQuery<IIndexMetaObjectQuery>(gql(indexMetaobjectQuery.query), {
    variables: { type: "index", first: 6, reverse: true },
    notifyOnNetworkStatusChange: true,
    onError: (error) => {
      throw new Error(error.message);
    },
  });

  const index = useMemo<MetafieldReferenceEdge[]>(() => {
    if (data) {
      return data?.metaobjects?.edges?.[0]?.node?.fields?.[0]?.references?.edges || [];
    }
    return [];
  }, [data]);

  return (
    <>
      {!data && loading ? null : (
        <section className="pc:col-span-12 pc:grid-cols-2 col-span-8 grid grid-cols-1 gap-x-5 gap-y-10">
          {index?.map(({ node }) => {
            const publishDate = new Date(getValue(node, "open_date")?.value || "");
            return serverTime > publishDate ? <HomeCard key={node?.id} node={node as Metaobject} /> : null;
          })}
        </section>
      )}
    </>
  );
}
